export default __webpack_public_path__ + "static/avatarJoca-32de9946fde6bd212bd3970705e673d6.jpeg";